// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3hcdH","content":"RecentSearches_content__2LJ7h"};